import React from "react";
import {
    Modal,ModalFooter,ModalHeader,
    Button,
    Card, CardHeader,CardBody, CardTitle, CardSubtitle, Table, Input, ModalBody, Label,
    FormGroup, CustomInput, Row, Col, Spinner
} from "reactstrap";
import utils from "../../../utils";
import Notification from "../../../components/Notification";
import {Plus, Edit, Trash2 } from "react-feather";
import { PAGES } from "../accessPages";
const apiAccessRole= require("../api/apiAccessRole");

function errorMessage(err){
    if(err && err.data && err.data._error_message) return err.data._error_message;
    return typeof err === "string" ? err : "Kiểm tra lại các trường đầu vào hoặc báo cho quản trị viên";
}

class Main extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            data: null,
            showForm: false,
            showDelete: false,
            editing: null, // access role being edited, null when creating
            name: "",
            description: "",
            allPages: false,
            pages: [],
            saving: false,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        apiAccessRole.listAccessRole((err,result)=>{
            if(err){
                Notification("error", "Có lỗi xảy ra ", errorMessage(err));
            } else {
                this.setState({ data: result });
            }
        });
    }

    openForm(row){
        this.setState({
            showForm: true,
            editing: row || null,
            name: row ? row.name : "",
            description: row && row.description ? row.description : "",
            allPages: row ? row.pages.indexOf("*") !== -1 : false,
            pages: row ? row.pages.filter(p => p !== "*") : [],
        });
    }

    closeForm(){
        if(!this.state.saving) this.setState({ showForm: false });
    }

    closeDelete(){
        if(!this.state.saving) this.setState({ showDelete: false });
    }

    togglePage(key){
        let pages = this.state.pages.slice();
        const index = pages.indexOf(key);
        if(index === -1) pages.push(key);
        else pages.splice(index, 1);
        this.setState({ pages: pages });
    }

    save(){
        if(utils.isEmpty(this.state.name)) return Notification("error", "Tên không được để trống");
        const pages = this.state.allPages ? ["*"] : this.state.pages;
        if(pages.length === 0) return Notification("error", "Chọn ít nhất một trang");
        const data = {
            name: this.state.name,
            description: this.state.description,
            pages: pages
        };
        const callback = (err)=>{
            this.setState({ saving: false });
            if(err){
                Notification("error", "Có lỗi xảy ra ", errorMessage(err));
            } else {
                Notification("success", "Lưu phân quyền thành công");
                this.setState({ showForm: false });
                this.loadData();
            }
        };
        this.setState({ saving: true });
        if(this.state.editing) apiAccessRole.editAccessRole(this.state.editing.id, data, callback);
        else apiAccessRole.createAccessRole(data, callback);
    }

    delete(){
        this.setState({ saving: true });
        apiAccessRole.deleteAccessRole(this.state.editing.id, (err)=>{
            this.setState({ saving: false });
            if(err){
                Notification("error", "Không thể xóa", errorMessage(err));
            } else {
                Notification("success", "Xóa phân quyền thành công");
                this.setState({ showDelete: false });
                this.loadData();
            }
        });
    }

    render() {
        return(
            <React.Fragment>
                <Modal isOpen={this.state.showForm} size="lg" centered toggle={this.closeForm.bind(this)}>
                    <ModalHeader toggle={this.closeForm.bind(this)}>
                        <b>{this.state.editing ? "Chỉnh sửa phân quyền" : "Thêm phân quyền"}</b>
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="accessRoleName" className="font-weight-bold">Tên</Label>
                            <Input id="accessRoleName" value={this.state.name} disabled={this.state.saving || (this.state.editing && this.state.editing.name === "Admin")} onChange={(e)=>this.setState({name: e.target.value})}/>
                        </FormGroup>
                        <FormGroup>
                            <Label for="accessRoleDescription" className="font-weight-bold">Mô tả</Label>
                            <Input id="accessRoleDescription" value={this.state.description} disabled={this.state.saving} onChange={(e)=>this.setState({description: e.target.value})}/>
                        </FormGroup>
                        <FormGroup className="mb-0">
                            <Label className="font-weight-bold">
                                Các trang được xem
                                <small className="text-muted ml-2">
                                    ({this.state.allPages ? "tất cả" : this.state.pages.length + "/" + PAGES.length})
                                </small>
                            </Label>
                            <div className="border rounded p-3">
                                <CustomInput type="checkbox" id="accessRoleAllPages" label="Tất cả các trang" className="font-weight-bold"
                                    disabled={this.state.saving}
                                    checked={this.state.allPages} onChange={()=>this.setState({allPages: !this.state.allPages})}/>
                                <hr className="my-2"/>
                                <div style={{maxHeight: "50vh", overflowY: "auto"}}>
                                    <Row>
                                        {
                                            PAGES.map(page => (
                                                <Col md="6" key={page.key} className="mb-2">
                                                    <CustomInput type="checkbox" id={"accessRolePage-" + page.key} label={page.label}
                                                        disabled={this.state.saving || this.state.allPages}
                                                        checked={this.state.allPages || this.state.pages.indexOf(page.key) !== -1}
                                                        onChange={this.togglePage.bind(this, page.key)}/>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                </div>
                            </div>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-end">
                        <Button color="secondary" outline disabled={this.state.saving} onClick={this.closeForm.bind(this)}>
                            Hủy bỏ
                        </Button>
                        <Button color="primary" disabled={this.state.saving} onClick={this.save.bind(this)}>
                            {this.state.saving ? <Spinner size="sm" className="mr-2"/> : null}
                            Lưu
                        </Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showDelete} centered toggle={this.closeDelete.bind(this)}>
                    <ModalHeader toggle={this.closeDelete.bind(this)}><b>Xóa phân quyền</b></ModalHeader>
                    <ModalBody className="text-center">
                        Xác nhận xóa phân quyền <b>{this.state.editing ? this.state.editing.name : ""}</b>?
                    </ModalBody>
                    <ModalFooter className="d-flex justify-content-end">
                        <Button color="secondary" outline disabled={this.state.saving} onClick={this.closeDelete.bind(this)}>
                            Hủy bỏ
                        </Button>
                        <Button color="danger" disabled={this.state.saving} onClick={this.delete.bind(this)}>
                            {this.state.saving ? <Spinner size="sm" className="mr-2"/> : null}
                            Xóa
                        </Button>
                    </ModalFooter>
                </Modal>

                <center><Card className="border w-75 m-3">
                    <CardHeader style={{backgroundColor: "#e9ecef"}}>
                        <CardTitle className="d-inline">
                            Danh sách phân quyền trang
                        </CardTitle>
                        <CardSubtitle className="float-right d-inline text-success">
                            <Plus onClick={this.openForm.bind(this, null)}/>
                        </CardSubtitle>
                    </CardHeader>
                    <CardBody>
                        {
                            this.state.data !== null && this.state.data.length !== 0
                            ?(
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>Tên</th>
                                            <th>Mô tả</th>
                                            <th>Số trang</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.data.map( (row,index) =>{
                                                return(
                                                    <tr key={row.id}>
                                                        <td>{row.name}</td>
                                                        <td>{row.description}</td>
                                                        <td>{row.pages.indexOf("*") !== -1 ? "Tất cả" : row.pages.length}</td>
                                                        <td width="80px">
                                                            <Edit className="d-inline mr-2" onClick={this.openForm.bind(this, row)}/>
                                                            <Trash2 className="d-inline" onClick={()=>this.setState({showDelete: true, editing: row})}/>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                            ): (
                                "DANH SÁCH TRỐNG"
                            )
                        }
                    </CardBody>
                </Card></center>
            </React.Fragment>
        );
    }
}

export default Main;
